import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { createRouterVistra } from './router/router'
import { createStoreVistra } from './store/store'
import { Buffer } from 'buffer';
// import './assets/css/app.less'

// //font awesome
// import "@/assets/font-awesome/css/all.css"
import '../node_modules/@fortawesome/fontawesome-pro/css/all.css' //webfont
//import '../node_modules/@fortawesome/fontawesome-pro/js/all.js' //svg

// //bootstrap
import '../node_modules/bootstrap/scss/bootstrap.scss'

import '../public/assets/css/ComponentesDevExtreme.css'
import "./styles/index.scss";

import 'vue3-markdown/dist/style.css'

//tema devextreme
//import 'devextreme/dist/css/dx.common.css'
//import '../public/assets/temas/dx.material.vistra.css'
//import '../public/assets/temas/dx.material.vistra-dark.css'

import { locale, loadMessages } from 'devextreme/localization'
import messagesPT from 'devextreme/localization/messages/pt.json'
loadMessages(messagesPT)
import messagesES from 'devextreme/localization/messages/es.json'
loadMessages(messagesES);

//vistra plugins e componentes
import { DCPlugin } from './funcoes/Util'

const app = createApp(App);  // o mount está no final do arquivo

//axios
import { ConfigAxios } from './funcoes/ConfigAxios'

const store = createStoreVistra(app);
locale(store.getters.idioma)

// Define Buffer globalmente no navegador
window.Buffer = Buffer;

console.log('Public path:', import.meta.env.BASE_URL)

window.isDebug = process.env.NODE_ENV == 'development';

window.isIOS = (() => {
    var iDevices = [
        'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
            'MacIntel'
        ];
        
        if (!!(navigator?.userAgentData?.platform || navigator?.platform)) {
            while (iDevices.length) {
                if ((navigator?.userAgentData?.platform || navigator?.platform) === iDevices.pop()){ return true; }
            }
        }
        
        return false;
    }
)();

//console
// Define your custom commands and emoji
const commands = [
    {
        emoji: '🦄',
        name: 'unicorn'
    },
    {
        emoji: '🍕',
        name: 'pizza'
    },
    {
        emoji: '🍺',
        name: 'beer'
    },
    {
        emoji: '💩',
        name: 'poo'
    },
    {
        emoji: '🤢',
        name: 'eww'
    },
    {
        emoji: '💀',
        name: 'skull'
    },
    {
        emoji: '💣',
        name: 'bomb'
    },
    {
        emoji: '👉',
        name: 'here'
    },
    {
        emoji: '👍',
        name: 'nice'
    },
    {
        emoji: '👎',
        name: 'bad'
    },
    {
        emoji: '👀',
        name: 'eye'
    },
    {
        emoji: '➕',
        name: 'plus'
    },
    {
        emoji: '✔',
        name: 'ok'
    },
    {
        emoji: '🕒',
        name: 'time'
    },
    {
        emoji: '🗿🍷',
        name: 'stone'
    },
];

commands.forEach(({
    name,
    emoji
}) => window.console[name] = (...args) => console.log(emoji, ...args));


window.getStackTrace = () => {
    let stack = new Error().stack || '';
    stack = stack.split('\n').map(function (line) { return line.trim(); });
    return stack.splice(stack[0] == 'Error' ? 2 : 1);
}

window.console.show = (...args) => {
    if (!window.isDebug) 
        return
    if (args.length == 1 && args[0] == undefined)
        return;
    var zeroPadding = (num, digit) => {
        var zero = '';
        for(var i = 0; i < digit; i++) {
            zero += '0';
        }
        return (zero + num).slice(-digit);
    }
    var cd = new Date();
    var agora = zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
    //console.log(`%c ${agora} %c`, 'background:#F78119;color:#2F4F4F;border-radius:2px;padding-top:2px', 'color:none', ...args, ` [ ${window.getStackTrace()[1]} ]`)
    console.log(`%c ${agora} %c`, 'background:#F78119;color:#2F4F4F;border-radius:2px;padding-top:2px', 'color:none', ...args)
};

window.console.stats = (...args) => {
    if (!window.isDebug) 
        return
    if (args.length == 1 && args[0] == undefined)
        return;
    var zeroPadding = (num, digit) => {
        var zero = '';
        for(var i = 0; i < digit; i++) {
            zero += '0';
        }
        return (zero + num).slice(-digit);
    }
    var cd = new Date();
    var agora = zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
    console.log(`%c ${agora} %c`, 'background:#F78119;color:#2F4F4F;border-radius:2px;padding-top:2px', 'color:none', '🕒', ...args)
}
window.console.warning = (...args) => {
    if (!window.isDebug) 
        return
    if (args.length == 1 && args[0] == undefined)
        return;

    console.log(`%c 💀 WARNING %c`, 'background:#FF0000;color:#FFFFFF;border-radius:2px;padding-top:2px', 'color:none', ...args, ` [ ${window.getStackTrace()[1]} ]`)
};

import VisModal from "./components/utilitarios/modal/Modal.vue"
import VisLoading from "./components/utilitarios/loading/Loading.vue"
import VisLinhaFormulario from "./components/utilitarios/formulario/RowFormulario.vue"
import VisCampoFormulario from "./components/utilitarios/formulario/CampoFormulario.vue"
import VisValidationErrorMessage from './components/utilitarios/formulario/ValidationErrorMessage.vue'
import VisGrupos from "./components/utilitarios/grupos/Grupos.vue"
import vClickOutside from 'v-click-outside'
import resize from "./directives/Resize";


//tem que ser na ordem que está abaixo, inclusive com o new ConfigAxios(app) no meio
app .use(store)
    .use(createRouterVistra(app))

new ConfigAxios(app)    

app .use(DCPlugin)
  //  .use(VueHotkey)

    .directive('click-outside', vClickOutside)
    .directive('resize', resize)
    //.directive('hotkey', VueHotkey)
    .component('vis-modal', VisModal)
    .component('vis-loading', VisLoading)
    .component('vis-campo-formulario', VisCampoFormulario)
    .component('vis-linha-formulario', VisLinhaFormulario)
    .component('vis-validation-error-message', VisValidationErrorMessage)
    // .component('vis-page-base', VisPageBase)
    .component('vis-grupos', VisGrupos)

    .mount('#app1');
